import { PublicKey } from "@solana/web3.js";
import { Id } from "./basic";
import { PublicKeyField } from "../serialization/PublicKeyField";
import { MARKET_MAP } from "../constants";
export class MarketId extends Id {
    constructor(key) {
        super(key);
    }
    static fromBase58(base58) {
        return MarketId.of(new PublicKey(base58));
    }
    static of(key) {
        return new MarketId(key);
    }
    static field(property) {
        return new MarketIdField(property);
    }
    getName() {
        var _a;
        return (_a = MARKET_MAP[this.toBase58()]) !== null && _a !== void 0 ? _a : "unknown";
    }
}
class MarketIdField extends PublicKeyField {
    constructor(property) {
        super(property);
    }
    fromPublicKey(pubKey) {
        return MarketId.of(pubKey);
    }
}
//# sourceMappingURL=MarketId.js.map